import UserHelperService from './user-helper-service';

/***
 * A Service containing helper functions involving users, roles, and permissions.
 */
const userHelper = angular
    .module('FacilityData.Common.UserHelper', [])
    .service('UserHelper', UserHelperService)
    .name;

export default userHelper;


// WEBPACK FOOTER //
// ./app/common/user-helper/user-helper.js